/**
 * ### WARNING: This file is generated from template, edit the file under build-resources/template ###
 */

const uecareApi = {
    url: "https://api.eucare.tw",
};

export default uecareApi;



// WEBPACK FOOTER //
// ./src/constants/app/apiServer/constants.js